import { createGlobalStyle } from 'styled-components'

const ReactTooltipStyleClass = createGlobalStyle`
.foobar {
  padding: 2px !important;
  box-shadow: 0 0 1em darkgrey;
  max-width: 500px;
  font-size: x-small;
  opacity: 0.98 !important;
  }
`

export default ReactTooltipStyleClass